import { JsonapiEntity, attribute, entity } from 'jsonapi-transformers';

@entity({ type: 'citation_styles' })
export class CitationStyle extends JsonapiEntity<CitationStyle> {
  @attribute() description: string;
  @attribute() is_default: boolean;
}
